import { StaffType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all staff
export const getStaff = async (branch_id?: string | number) => {
  const url = branch_id
    ? `${ServiceEndpoints.STAFF}?branch_id=${branch_id}`
    : ServiceEndpoints.STAFF;

  return axios
    .get(url)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new staff
export const createStaff = async (data: StaffType) => {
  return axios
    .post(ServiceEndpoints.STAFF, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a staff by its ID
export const getStaffById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.STAFF}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing staff
export const updateStaff = async (id: string, data: StaffType) => {
  const { ...staffData } = data;

  return axios
    .put(`${ServiceEndpoints.STAFF}/${id}`, staffData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a staff
export const deleteStaff = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.STAFF}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
